<template>
  <svg
    t="1708239178755"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4610"
    id="mx_n_1708239178756"
    width="14"
    height="14"
  >
    <path d="M0 0l128 0 0 128-128 0 0-128Z" fill="#1296db" p-id="4611"></path>
    <path d="M256 0l768 0 0 128-768 0 0-128Z" fill="#1296db" p-id="4612"></path>
    <path d="M0 448l128 0 0 128-128 0 0-128Z" fill="#1296db" p-id="4613"></path>
    <path d="M256 448l768 0 0 128-768 0 0-128Z" fill="#1296db" p-id="4614"></path>
    <path d="M0 896l128 0 0 128-128 0 0-128Z" fill="#1296db" p-id="4615"></path>
    <path d="M256 896l768 0 0 128-768 0 0-128Z" fill="#1296db" p-id="4616"></path>
  </svg>
</template>
